class CartDrawer extends HTMLElement {
	constructor() {
		super();

		this.addEventListener(
			"keyup",
			(evt) => evt.code === "Escape" && this.close()
		);
		this.querySelector("#CartDrawer-Overlay").addEventListener(
			"click",
			this.close.bind(this)
		);
		this.setHeaderCartIconAccessibility();
	}

	setHeaderCartIconAccessibility() {
		const cartLink = document.querySelector("#cart-icon-bubble");
		cartLink.setAttribute("role", "button");
		cartLink.setAttribute("aria-haspopup", "dialog");

		cartLink.addEventListener("click", (event) => {
			event.preventDefault();
			this.open(cartLink);
		});

		cartLink.addEventListener("keydown", (event) => {
			if (event.code.toUpperCase() === "SPACE") {
				event.preventDefault();
				this.open(cartLink);
			}
		});
	}

	open(triggeredBy) {
		if (triggeredBy) this.setActiveElement(triggeredBy);
		const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
		if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
			this.setSummaryAccessibility(cartDrawerNote);

		// here the animation doesn't seem to always get triggered. A timeout seem to help
		setTimeout(() => {
			this.classList.add("animate", "active");
		});

		this.addEventListener(
			"transitionend",
			() => {
				const containerToTrapFocusOn = this.classList.contains("is-empty")
					? this.querySelector(".drawer__inner-empty")
					: document.getElementById("CartDrawer");
				const focusElement =
					this.querySelector(".drawer__inner") ||
					this.querySelector(".drawer__close");
				trapFocus(containerToTrapFocusOn, focusElement);
			},
			{ once: true }
		);

		document.body.classList.add("cart-overflow-hidden");

		if (!isSafari()) {
			document.body.classList.add("overflow-hidden");
		} else {
			document.body.classList.add("overflow-clip");
		}
	}

	close() {
		this.classList.remove("active");
		removeTrapFocus(this.activeElement);
		document.body.classList.remove("cart-overflow-hidden");

		if (!isSafari()) {
			document.body.classList.remove("overflow-hidden");
		} else {
			document.body.classList.remove("overflow-clip");
		}

		// setTimeout(() => {
		// 	let notification = this.querySelector(".notification");

		// 	if (notification) {
		// 		const activeItem = this.querySelector(
		// 			`.cart-item[data-product-id="${this.productId}"`
		// 		);
		// 		notification.classList.remove("notification-open");
		// 		activeItem?.classList.remove("active");
		// 	}
		// }, 1000);


		setTimeout(() => {
    let notification = this.querySelector(".notification");
    if (notification) {
        notification.classList.remove("notification-open");
    }
    // active class mat hatao — sabhi items visible rahen
}, 1000);
	}

	setSummaryAccessibility(cartDrawerNote) {
		cartDrawerNote.setAttribute("role", "button");
		cartDrawerNote.setAttribute("aria-expanded", "false");

		if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
			cartDrawerNote.setAttribute(
				"aria-controls",
				cartDrawerNote.nextElementSibling.id
			);
		}

		cartDrawerNote.addEventListener("click", (event) => {
			event.currentTarget.setAttribute(
				"aria-expanded",
				!event.currentTarget.closest("details").hasAttribute("open")
			);
		});

		cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
	}

	// renderContents(parsedState) {
	// 	this.querySelector(".drawer__inner").classList.contains("is-empty") &&
	// 		this.querySelector(".drawer__inner").classList.remove("is-empty");
	// 	this.productId = parsedState.id;
	// 	this.getSectionsToRender().forEach((section) => {
	// 		const sectionElement = section.selector
	// 			? document.querySelector(section.selector)
	// 			: document.getElementById(section.id);
	// 		sectionElement.innerHTML = this.getSectionInnerHTML(
	// 			parsedState.sections[section.id],
	// 			section.selector
	// 		);
	// 	});

	// 	let notification = this.querySelector(".notification");

	// 	if (notification) {
	// 		const activeItem = this.querySelector(
	// 			`.cart-item[data-product-id="${this.productId}"`
	// 		);
	// 		notification.classList.add("notification-open");
	// 		activeItem.classList.add("active");
	// 	}

	// 	setTimeout(() => {
	// 		this.querySelector("#CartDrawer-Overlay").addEventListener(
	// 			"click",
	// 			this.close.bind(this)
	// 		);
	// 		this.open();
	// 	});
	// }

	renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
        this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
        sectionElement.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
        );
    });

    // Sabhi cart items ko active karo
    this.querySelectorAll('.cart-item').forEach(item => {
        item.classList.add('active');
    });

    setTimeout(() => {
        this.querySelector("#CartDrawer-Overlay").addEventListener(
            "click",
            this.close.bind(this)
        );
        this.open();
    });
}

	getSectionInnerHTML(html, selector = ".shopify-section") {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector).innerHTML;
	}

	getSectionsToRender() {
		return [
			{
				id: "cart-drawer",
				selector: "#CartDrawer",
			},
			{
				id: "cart-icon-bubble",
			},
		];
	}

	getSectionDOM(html, selector = ".shopify-section") {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector);
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
	getSectionsToRender() {
		return [
			{
				id: "CartDrawer",
				section: "cart-drawer",
				selector: ".drawer__inner",
			},
			{
				id: "cart-icon-bubble",
				section: "cart-icon-bubble",
				selector: ".shopify-section",
			},
		];
	}
}

customElements.define("cart-drawer-items", CartDrawerItems);

if (!customElements.get("cart-note")) {
	customElements.define(
		"cart-note",
		class CartNote extends HTMLElement {
			constructor() {
				super();

				this.addEventListener(
					"input",
					debounce((event) => {
						const body = JSON.stringify({ note: event.target.value });
						fetch(`${routes.cart_update_url}`, {
							...fetchConfig(),
							...{ body },
						});
					}, ON_CHANGE_DEBOUNCE_TIMER)
				);
			}
		}
	);
}




// ===================== CART UPSELL - DYNAMIC ===================== //

async function getCartItems() {
  const res = await fetch('/cart.js');
  const cart = await res.json();
  return cart.items;
}

async function getProductsByCollection(collectionHandle, limit = 20) {
  const res = await fetch(`/collections/${collectionHandle}/products.json?limit=${limit}`);
  const data = await res.json();
  return data.products;
}

async function getAllProducts(limit = 20) {
  const res = await fetch(`/products.json?limit=${limit}`);
  const data = await res.json();
  return data.products;
}

function getHighestCartPrice(cartItems) {
  return Math.max(...cartItems.map(item => item.price));
}

function getCartProductIds(cartItems) {
  return cartItems.map(item => item.product_id);
}


function formatMoney(price) {
  return '₹' + parseFloat(price).toLocaleString('en-IN', { minimumFractionDigits: 2 });
}

function buildUpsellCard(product) {
  const variant = product.variants[0];
  const image = product.images[0] ? product.images[0].src : '';

  const variantOptions = product.variants.length > 1
    ? `<select class="cart-upsell__variant-select" data-product-handle="${product.handle}">
        ${product.variants.map(v => `
          <option value="${v.id}" ${!v.available ? 'disabled' : ''}>
            ${v.title}
          </option>
        `).join('')}
       </select>`
    : `<input type="hidden" class="cart-upsell__variant-select" value="${variant.id}">`;

  return `
    <div class="swiper-slide cart-upsell__card" data-product-id="${product.id}">
      <div class="cart-upsell__image">
        ${image ? `<img src="${image}" alt="${product.title}" width="70" height="70" loading="lazy">` : ''}
      </div>
      <div class="cart-upsell__info">
        <p class="cart-upsell__title">${product.title.toUpperCase()}</p>
        ${variantOptions}
        <p class="cart-upsell__price">${formatMoney(variant.price)}</p>
      </div>
      <button class="cart-upsell__add-btn" type="button">Add</button>
    </div>
  `;
}

function initUpsellSwiper() {
  if (typeof Swiper === 'undefined') {
    setTimeout(initUpsellSwiper, 300);
    return;
  }

  const swiperEl = document.querySelector('.cart-upsell-swiper');
  if (!swiperEl) return;
  if (swiperEl.swiper) swiperEl.swiper.destroy(true, true);

  const totalSlides = swiperEl.querySelectorAll('.swiper-slide').length;
  const counter = document.querySelector('.cart-upsell__counter');
  if (counter) counter.textContent = `1 / ${totalSlides}`;

  new Swiper('.cart-upsell-swiper', {
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      nextEl: '.cart-upsell-next',
      prevEl: '.cart-upsell-prev',
    },
    on: {
      slideChange: function () {
        if (counter) {
          counter.textContent = `${this.activeIndex + 1} / ${totalSlides}`;
        }
      }
    }
  });
}

function bindUpsellButtons() {
  document.querySelectorAll('.cart-upsell__add-btn').forEach(btn => {
    if (btn.dataset.bound) return;
    btn.dataset.bound = 'true';

    btn.addEventListener('click', function () {
      const card = this.closest('.cart-upsell__card');
      const select = card.querySelector('.cart-upsell__variant-select');
      const variantId = select.value;
      if (!variantId) return;

      btn.textContent = '...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(r => r.json())
      .then(() => {
        btn.textContent = '✓';

        fetch('/?sections=cart-drawer')
          .then(res => res.json())
          .then(data => {
            if (data['cart-drawer']) {
              const parser = new DOMParser();
              const doc = parser.parseFromString(data['cart-drawer'], 'text/html');

              const newItems = doc.querySelector('#CartDrawer-CartItems');
              const currentItems = document.querySelector('#CartDrawer-CartItems');
              if (newItems && currentItems) currentItems.innerHTML = newItems.innerHTML;

              const newCount = doc.querySelector('.cart-count-bubble');
              const currentCount = document.querySelector('.cart-count-bubble');
              if (newCount && currentCount) currentCount.innerHTML = newCount.innerHTML;

              const newSubtotal = doc.querySelector('.totals__subtotal-value');
              const currentSubtotal = document.querySelector('.totals__subtotal-value');
              if (newSubtotal && currentSubtotal) currentSubtotal.innerHTML = newSubtotal.innerHTML;

              const newHeading = doc.querySelector('.drawer__heading');
              const currentHeading = document.querySelector('.drawer__heading');
              if (newHeading && currentHeading) currentHeading.innerHTML = newHeading.innerHTML;

              // Upsell refresh after cart update
              loadUpsellProducts();
            }
          });

        setTimeout(() => {
          btn.textContent = 'Add';
          btn.disabled = false;
        }, 1500);
      })
      .catch(() => {
        btn.textContent = 'Add';
        btn.disabled = false;
      });
    });
  });
}

async function loadUpsellProducts() {
  const wrapper = document.getElementById('cart-upsell-wrapper');
  if (!wrapper) return;

  wrapper.innerHTML = `<div class="swiper-slide cart-upsell__loading">Loading...</div>`;

  try {
    const cartItems = await getCartItems();
    if (!cartItems.length) {
      document.getElementById('cart-upsell-section').style.display = 'none';
      return;
    }

    const highestCartPrice = Math.max(...cartItems.map(item => item.price)) / 100;
    const cartProductIds = getCartProductIds(cartItems);

    const allProducts = await getAllProducts(250);

    const upsellProducts = allProducts.filter(product => {
      const productPrice = parseFloat(product.variants[0].price);
      const notInCart = !cartProductIds.includes(product.id);
      const higherPrice = productPrice > highestCartPrice;
      return notInCart && higherPrice;
    });

    if (!upsellProducts.length) {
      document.getElementById('cart-upsell-section').style.display = 'none';
      return;
    }

    document.getElementById('cart-upsell-section').style.display = 'block';
    wrapper.innerHTML = upsellProducts.map(buildUpsellCard).join('');

    initUpsellSwiper();
    bindUpsellButtons();

  } catch (err) {
    console.error('Upsell error:', err);
    wrapper.innerHTML = '';
  }
}

const cartUpsellObserver = new MutationObserver(function () {
  const section = document.getElementById('cart-upsell-section');
  if (section && !section.dataset.loaded) {
    section.dataset.loaded = 'true';
    loadUpsellProducts();
  }
});

cartUpsellObserver.observe(document.body, {
  childList: true,
  subtree: true
});

document.addEventListener('DOMContentLoaded', function () {
  if (document.getElementById('cart-upsell-section')) {
    loadUpsellProducts();
  }
});
